import { Link } from "react-router-dom";
import { assets } from "@/lib/config";
import { Reveal } from "./Reveal";
import { MonoLabel, btnOutline, btnPrimary } from "./primitives";

/** Final cinematic CTA. */
export function CTASection() {
  return (
    <section className="relative overflow-hidden border-t border-line" data-testid="final-cta">
      <img
        src={assets.banner}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-[center_35%] opacity-25"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_50%_50%,rgba(0,102,255,0.14),transparent_70%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,#02050A_0%,rgba(2,5,10,0.72)_30%,rgba(2,5,10,0.72)_70%,#02050A_100%)]" />

      <div className="container-t relative z-10 py-28 text-center sm:py-36">
        <Reveal>
          <MonoLabel className="text-[9px]">Final Transmission</MonoLabel>
          <h2
            className="mx-auto mt-6 max-w-4xl font-display text-4xl font-bold uppercase leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl"
            data-testid="final-cta-title"
          >
            What will your action <span className="text-cyan glow-cyan">leave behind?</span>
          </h2>
          <p className="mt-8 font-display text-lg font-semibold uppercase tracking-[0.14em] text-dim sm:text-xl">
            Consequence Protocol
          </p>
          <p className="mt-3 font-mono text-xs uppercase tracking-[0.24em] text-dim sm:text-sm">
            Verify the action · Measure the outcome · Build the reputation
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link to="/terminal" data-testid="final-cta-enter-terminal" className={btnPrimary}>
              Enter Consequence Terminal
            </Link>
            <Link to="/protocol" data-testid="final-cta-read-protocol" className={btnOutline}>
              Read the Protocol
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
